<template>
	<div class="">
		<HomeSanDianLiu v-if="config.ui_version==3.6"></HomeSanDianLiu>
		<HomeConter v-if="config.ui_version==3.0"></HomeConter>
		<HomeSanDian5 v-if="config.ui_version==3.5"></HomeSanDian5>
	</div>
</template>
<script>
	import HomeSanDianLiu from "@/components/home/HomeSanDianLiu.vue"
	import HomeConter from "@/components/home/HomeConter.vue"
	import HomeSanDian5 from "@/components/home/HomeSanDian5.vue"
	import four from "@/components/home/four.vue"
	import { mapState } from 'vuex';
	export default {
		computed:{
			...mapState(['popList','userInfo','moneyInfo','config'])
		},
		name: 'Home',
		components: {
			HomeSanDianLiu,
			HomeConter,
			HomeSanDian5,
			four,
		},
		data() {
			return {
				isConterType:2,
			}
		},
		created() {
			
		},
		mounted() {
		
		},
		beforeDestroy() {
		},
		methods: {
		
		}
	}
</script>

